var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.257 13.6772H136.717V37.5138H171.257V13.6772Z",
    fill: "#FFD200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.344 30.276C149.164 30.2748 148.99 30.2139 148.849 30.1029L143.674 25.9935C143.579 25.9203 143.502 25.8259 143.449 25.7178C143.396 25.6096 143.369 25.4906 143.369 25.3702C143.368 25.2494 143.395 25.13 143.447 25.021C143.499 24.9121 143.574 24.8163 143.668 24.7411L148.843 20.5567C148.925 20.4904 149.019 20.4409 149.12 20.4111C149.221 20.3813 149.327 20.3717 149.432 20.383C149.537 20.3943 149.638 20.4261 149.73 20.4767C149.823 20.5273 149.904 20.5956 149.97 20.6779C150.036 20.7601 150.086 20.8546 150.115 20.956C150.145 21.0573 150.155 21.1636 150.143 21.2686C150.132 21.3736 150.101 21.4754 150.05 21.5682C150 21.6609 149.932 21.7428 149.85 21.8091L145.451 25.3644L149.844 28.8273C149.974 28.9309 150.069 29.0728 150.116 29.2332C150.162 29.3936 150.157 29.5645 150.102 29.722C150.047 29.8796 149.944 30.016 149.808 30.1122C149.672 30.2084 149.51 30.2596 149.344 30.2587V30.276Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.722 30.2762C158.552 30.2808 158.384 30.2308 158.245 30.1333C158.105 30.0358 157.999 29.896 157.944 29.7343C157.889 29.5726 157.887 29.3974 157.938 29.2343C157.989 29.0712 158.09 28.9287 158.227 28.8276L162.615 25.3646L158.222 21.8151C158.14 21.7492 158.072 21.6677 158.021 21.5753C157.97 21.4829 157.939 21.3814 157.927 21.2766C157.916 21.1719 157.925 21.0658 157.954 20.9646C157.983 20.8634 158.032 20.769 158.098 20.6868C158.164 20.6045 158.245 20.5361 158.337 20.4854C158.429 20.4346 158.53 20.4026 158.634 20.391C158.739 20.3795 158.845 20.3887 158.945 20.4182C159.046 20.4476 159.14 20.4967 159.222 20.5627L164.397 24.7471C164.496 24.8169 164.578 24.9092 164.635 25.0165C164.692 25.1238 164.722 25.2431 164.725 25.3646C164.725 25.4845 164.699 25.6029 164.647 25.7109C164.595 25.8188 164.52 25.9136 164.426 25.988L159.251 30.0973C159.101 30.2179 158.914 30.2813 158.722 30.2762Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.862 30.2762C151.747 30.2768 151.633 30.2511 151.529 30.2012C151.336 30.1131 151.186 29.9518 151.111 29.7526C151.037 29.5535 151.044 29.3329 151.132 29.1392L154.904 20.8455C154.994 20.6525 155.156 20.503 155.355 20.4295C155.555 20.356 155.775 20.3644 155.968 20.453C156.063 20.4965 156.149 20.5586 156.221 20.6357C156.292 20.7128 156.348 20.8034 156.384 20.9021C156.42 21.0009 156.437 21.1059 156.433 21.2111C156.428 21.3163 156.403 21.4196 156.359 21.515L152.587 29.8087C152.523 29.9479 152.421 30.066 152.293 30.1488C152.164 30.2316 152.015 30.2759 151.862 30.2762Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6584 11.8477H3.61011V77.4358H42.6584V11.8477Z",
    fill: "#24285B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 12.0898H53.0024V62.643H125.332V12.0898Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 62.6372H53.0024V112.273H125.332V62.6372Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.121 70.6191H60.9031V94.1902H118.121V70.6191Z",
    fill: "#C9C9C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.492 97.1167H77.7563V108.048H100.492V97.1167Z",
    fill: "#C9C9C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.542 16.7881H57.7231V56.6235H120.542V16.7881Z",
    fill: "#24285B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2539 44.457H76.0771V46.7253H96.2539V44.457Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9052 38.1426H81.8674V40.4108H99.9052V38.1426Z",
    fill: "#FFD200"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.914 49.9341H81.8674V52.2023H105.914V49.9341Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6356 49.9341H68.5908V52.2023H77.6356V49.9341Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8509 44.457H62.8062V46.7253H71.8509V44.457Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8345 21.6765C62.422 21.6765 62.8982 21.1985 62.8982 20.6088C62.8982 20.0191 62.422 19.541 61.8345 19.541C61.247 19.541 60.7708 20.0191 60.7708 20.6088C60.7708 21.1985 61.247 21.6765 61.8345 21.6765Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M76.0772 75.133C76.0772 75.133 83.5867 73.5631 81.8675 80.8353C80.1482 88.1075 85.8925 87.1205 84.777 92.8171C83.6615 98.5136 76.0772 112.273 76.0772 112.273H61.8345L69.0795 85.4756L76.0772 75.133Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9971 21.6765C65.5846 21.6765 66.0609 21.1985 66.0609 20.6088C66.0609 20.0191 65.5846 19.541 64.9971 19.541C64.4096 19.541 63.9333 20.0191 63.9333 20.6088C63.9333 21.1985 64.4096 21.6765 64.9971 21.6765Z",
    fill: "#0D9F3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M110.485 77.8514C110.485 77.8514 117.523 74.5962 120.536 80.7833C123.549 86.9704 125.332 88.5692 125.332 88.5692V108.048L109.899 96.4069L110.485 77.8514Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9812 21.6765C68.5687 21.6765 69.045 21.1985 69.045 20.6088C69.045 20.0191 68.5687 19.541 67.9812 19.541C67.3937 19.541 66.9175 20.0191 66.9175 20.6088C66.9175 21.1985 67.3937 21.6765 67.9812 21.6765Z",
    fill: "#FFD200"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8509 27.2173H62.8062V29.4855H71.8509V27.2173Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6356 32.8848H68.5908V35.153H77.6356V32.8848Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9052 32.8848H81.8674V35.153H99.9052V32.8848Z",
    fill: "#FFD200"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6356 38.1426H68.5908V40.4108H77.6356V38.1426Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0919 27.2173H75.4619V29.4855H94.0919V27.2173Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.215 27.2173H97.9905V29.4855H111.215V27.2173Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M109.899 100.822C109.899 100.822 100.359 98.4671 101.09 92.7417C101.82 87.0163 107.99 90.2368 107.99 90.2368C107.99 90.2368 106.374 82.4394 104.028 80.2232C101.682 78.0069 106.667 74.1976 110.485 77.8741C114.303 81.5506 115.039 78.6013 118.121 82.4279C121.203 86.2544 121.203 97.1396 121.203 97.1396L109.899 100.822Z",
    fill: "#F4A28C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M109.899 100.828L118.121 133.541L136.032 126.465L121.203 97.1167L109.899 100.828Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3101 97.7286C70.3101 97.7286 79.8494 95.3681 79.1191 89.6484C78.3889 83.9288 72.2191 87.1436 72.2191 87.1436C72.2191 87.1436 73.8291 79.352 76.1809 77.1299C78.5326 74.9079 73.5359 71.1102 69.7179 74.7809C65.8999 78.4516 65.1696 75.5081 62.0876 79.3404C59.0056 83.1727 59.0056 94.0464 59.0056 94.0464L70.3101 97.7286Z",
    fill: "#F4A28C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.31 97.7282L62.0875 130.441L44.1763 123.366L59.0055 94.0171L70.31 97.7282Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6504 31.9209H29.9794V55.7921",
    stroke: "white",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4212 17.5669H9.48071V20.6085H28.4212V17.5669Z",
    fill: "#FFD200"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6414 28.8101H10.6594V35.0318H20.6414V28.8101Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6504 55.792H29.8126",
    stroke: "white",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9705 41.04H24.9885V47.2618H34.9705V41.04Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6414 52.6812H10.6594V58.9029H20.6414V52.6812Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8038 52.6812H24.8218V58.9029H34.8038V52.6812Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M34.8094 67.2256H10.6594V71.6466H34.8094V67.2256Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M176.771 48.3989H136.596V71.7218H176.771V48.3989Z",
    fill: "#E6E6E6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M143.461 58.1587C144.751 58.1587 145.796 57.1096 145.796 55.8154C145.796 54.5213 144.751 53.4722 143.461 53.4722C142.172 53.4722 141.127 54.5213 141.127 55.8154C141.127 57.1096 142.172 58.1587 143.461 58.1587Z",
    fill: "#24285B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M143.461 66.314C144.751 66.314 145.796 65.2649 145.796 63.9707C145.796 62.6766 144.751 61.6274 143.461 61.6274C142.172 61.6274 141.127 62.6766 141.127 63.9707C141.127 65.2649 142.172 66.314 143.461 66.314Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M169.906 54.2168H148.855V57.0679H169.906V54.2168Z",
    fill: "#C9C9C9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M169.906 62.4644H148.855V65.3155H169.906V62.4644Z",
    fill: "#C9C9C9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.62ce24bbcd53222f838103757810f9f5.svg";
export { ForwardRef as ReactComponent };